<template>
  <div id="uvcontent">

    <div v-if="!loading" class="content-warp">
      <div style="width: 100%; height: 30px"></div>
      <div class="video_placeholder" :style="{height:video_height+'px'}">
<!--        <layVideo :height="video_height" :src="playersrc" :poster="poster"></layVideo>-->
        <video width="100%" :style="{height:video_height+'px'}" :poster="poster" controls="controls" preload="meta" x-webkit-airplay="true" webkit-playsinline="true" playsinline="true" x5-video-player-type="h5" x5-video-player-fullscreen="true" :src="playersrc"><source src="" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>


      <div class="video-user-info" v-if="!showloading && data.movie_numbers.realname">
        <div class="video-user-info-l">
          <img :src="data.movie_numbers.head_img+'?x-oss-process=image/resize,m_lfit,h_70,w_70'">
          <div class="video-user-info-t">
            <div class="video-user-info-title text-overflow-one">{{data.movie_numbers.realname}}</div>
            <div class="video-user-info-desc text-overflow-one">
              {{data.movie_info.publish_time}} {{data.movie_numbers.intro}}
            </div>
          </div>
        </div>



      </div>

      <div class="scrollView" >

        <div class="content">
          <div class="content-title">{{data.movie_info.title}}</div>
          <div class="content-text font-nomal" v-html="TextAreaText2Html(data.movie_info.content)">

          </div>
        </div>
        <div class="bottom-line"></div>




        <div class="video-more-warp">
          <div class="left-img-list">
            <div class="left-img-list-item" v-for="(item,index) in data.about_list" @click.stop="openContent(item)" >
              <div class="news-list-item-row">
                <img v-if="item.thumb"  v-lazy="item.thumb+'?x-oss-process=image/resize,m_lfit,h_360,w_380'" :style="{width:w+'px'}" class="news-list-item-img news-list-item-img-left" >
                <div class="news-list-item-row-left">
                  <div class="news-list-item-title text-overflow" v-html="item.movie_name"></div>

                  <div class="news-list-item-date">


                    <span>{{item.publish_time}}</span>

                  </div>
                </div>


              </div>

            </div>
          </div>
        </div>



        <!-- 全部评论-->
        <div class="replay-containner">
          <div class="replay-containner-title">全部评论</div>
          <div class="replay-empty" v-if="replaylist.length === 0" >查看精彩评论请下载看度时政客户端</div>

          <div v-for="item in replaylist" v-else>
            <div class="replay-item" >
              <!--                <img class="replay-item-avatar" :src="item.head_img" @error="setdefaultImg($event)">-->
              <img class="replay-item-avatar" :src="item.head_img" @error="setdefaultImg($event)">

              <div class="replay-item-c">
                <div class="replay-item-name">
                  <div class="replay-item-name-user">{{item.user_name}}</div>
                  <!--                            <div class="replay-item-name-praise">-->
                  <!--                                <img src="../../../image/replay-praise.png">-->
                  <!--                                <span>赞</span>-->
                  <!--                            </div>-->
                </div>

                <div class="replay-item-content" v-html="item.content"></div>
                <div class="replay-item-info">
                  <span>{{item.create_time}}&nbsp;</span>
                  <i></i>
                  <span class="replay-item-content-replay" @click="replayitem(item)" v-if="item.com_id">{{item.reply_num?item.reply_num:''}}回复</span>
                </div>
              </div>
            </div>
            <div class="replay-item replay-item-child " v-if="item.children && item.children.length>0" v-for="item2 in item.children">
              <img class="replay-item-avatar" :src="item2.head_img" @error="setdefaultImg($event)">
              <div class="replay-item-c">
                <div class="replay-item-name">
                  <div class="replay-item-name-user">{{item2.user_name}}</div>
                </div>
                <div class="replay-item-content" v-html="item2.content"></div>
                <div class="replay-item-info">
                  <span>{{item2.create_time}}&nbsp;</span>

                </div>
              </div>
            </div>
          </div>




        </div>

      </div>



    </div>

    <div class="c-loading" v-if="loading">
      <div class="c-loading-c">
        <img src="../assets/loading.svg">
        <div>加载中...</div>
      </div>

    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import request from "../utils/request";
import utils from "../utils";
import layVideo from '@/components/Video.vue'
var firstload = true;
export default {
  name: 'videoProgramContent',
  components: {
    layVideo
  },
  mounted(){
    var w = document.getElementById("home").offsetWidth;
    this.item_width = parseInt((w-30)/3.2);
    this.item_height=((w-30)/3.2)/(3/4);
    this.video_height=w/(16/9);
    this.w = (w-30)/3
  },
  created() {
    // document.querySelector(".toplink").style.display = 'none';
    this.getdata()
  },
  data(){
    return {
      id:this.$route.params.id,
      item_width:400,
      item_height:300,
      video_height:200,
      loading:true,
      showloading:true,

      data: {
        about_list: [],
        praise_num:0,
        movie_numbers:{
          head_img:"",
          realname:""
        },
        movie_info:{}
      },
      playersrc:"",
      poster:"",
      w:100,
      replaylist:[]
    }
  },
  methods:{
    TextAreaText2Html: function TextAreaText2Html(text) {
      return utils.TextAreaText2Html(text);
    },
    openContent(item){
      this.replaylist = [];
      this.id = item.movie_id;
      this.getdata();
    },
    getreplay: function getreplay() {

      var _this4 = this;

      var page = this.replaypage;
      request.getVideoReplayList2(this.id,function (res, err) {
        if (err) {
          return;
        }

        if (res.code == 200) {


          var replaylist = _this4.replaylist.concat(res.data.data);
          console.log(replaylist)

          _this4.replaylist = replaylist
        }
      });
    },
    getdata(refresh) {

      var _this5 = this;


      this.getreplay();

      request.movie_numbers_info({
        mn_article_id:this.id,

      }, function (res, err) {
        _this5.loading = false;


        if (err) {

        } else if (res && res.code == 200) {
          _this5.data = res.data;

          _this5.showloading = false


          try {

              _this5.praised = res.data.is_praise; // this.replaylist = res.data.com_list.data
              // this.replaynumber = res.data.com_list.total>99 ?'99+':res.data.com_list.total;


            _this5.playersrc =res.data.movie_info.play_info.path;
            _this5.poster = res.data.movie_info.thumb;



            _this5.$forceUpdate();
          } catch (e) {
            console.log(e);
          }

          request.getWeixinShanre(location.href,(s_res)=>{
            let {appId,timestamp,nonceStr,signature,thumb} = s_res.data;
            thumb = _this5.data.movie_numbers.head_img+'?x-oss-process=image/resize,m_lfit,h_100,w_100';

            let shareconfig = {appId,timestamp,nonceStr,signature};
            if(utils.is_weixin()){
              if(res.data){
                let sharedata = {
                  title:res.data.movie_info.title,
                  desc:res.data.movie_info.content?res.data.movie_info.content:"看度时政",
                  link:location.href,
                  imgUrl:thumb
                };
                utils.setWeiXinShare(sharedata,shareconfig,false)
              }

            }
          });

        } else {
          _this5.loading = true;
          if(res.message){
            alert(res.message)
          }
          console.log('qingqiu');
        }
      });
    },

    play_item:function(item){
      if(this.current_vid == item.v_id){
        return
      }
      this.current_vid = item.v_id;
      request.getVideo(item.v_id, (video_res)=> {

        this.playersrc = video_res.data

      })

    },
    elementScroll: function elementScroll(e) {
      var _this2 = this;

      this.scrolltop = e.target.scrollTop; //滚动到了底部
      if(this.specsub_imgthumb){
        var opactiy = e.target.scrollTop/100;
        if(opactiy<0){
          opactiy = 0
        }else if(opactiy>1){
          opactiy = 1
        }
        this.header_opactiy = opactiy;
      }
      if (this.scrollbottom) {
        var topheight = e.target.offsetHeight + e.target.scrollTop;

        if (topheight + 30 >= e.target.scrollHeight && this.lastscroll < e.target.scrollTop) {
          if (this.scrollTopTimeOut) {
            clearTimeout(this.scrollTopTimeOut);
            this.scrollTopTimeOut = false;
          }
          this.scrollTopTimeOut = setTimeout(function () {
            _this2.scrollbottom();
          }, 300);
        }
        this.lastscroll = e.target.scrollTop;
      }
    },
    scrollbottom: function scrollbottom() {
      this.getdata();
    },
  }
}
</script>
<style scoped>
  @import '../assets/css/listcomponentscss.css';
  .div_video_warp{ background-image: url("../assets/videl_lanmu_list.png"); background-size: 100% 100%; background-repeat: no-repeat; padding-bottom: 10px}
  .video_placeholder{ width: 100%}
  .video_info{ padding:10px 15px; color: #fff}
  .video_info-title{ padding: 0 10px; background-image: url(../assets/shanjiao_while.png); background-repeat: no-repeat; background-position:0 6px; background-size:10px;
    font-size: 16px; font-weight: bold; line-height: 24px;}
  .video_info-desc{ font-size: 14px; line-height: 24px; text-align: justify;padding: 0 10px;}
  .video-year{ position: relative; border-radius: 10px; background-color: #fff; top:-10px; padding-bottom:5px; color: #fff; padding-top: 15px; width: 100%}
  .video-year .scroll-x-item{ padding: 0 5px; margin-left: 10px; font-size: 16px; line-height: 24px; position: relative; height: 24px; border-radius: 15px;color: #000;}
  .video-year .scroll-x-item:last-child{ margin-right: 10px}
  .video-year .scroll-x-item.active{color: #c22024; background-color: #eaeaea; font-weight: bold}



  .left-img-list-item.active .news-list-item-title{ color: red}

  .content-warp{height: 100vh; display: flex; flex-direction: column; max-width: 640px; margin: auto}

  .content-title{ font-size: 16px; color: #323232; padding: 15px 0; font-weight: bold; padding-top: 0; padding-bottom: 10px; line-height: 24px;text-align: justify}
  .content-title span{ vertical-align: middle}
  .content-text{ font-size: 16px; color: #8e8e8e; line-height:28px;text-align: justify}

  .bottom-line{ width: 100%; height: 5px; background-color: #e8e8e8; margin-bottom: 10px}
  .video-user-info{ padding:15px; margin-bottom: 0; padding-bottom: 10px}
  .video-more-warp{ padding-top: 10px}
  .replay-item-child{ padding-left: 50px; box-sizing: border-box}


</style>
